import {
  GRAPH_MODAL_REQUEST,
  GRAPH_MODAL_REQUEST_SUCCESS,
  GRAPH_MODAL_REQUEST_ERROR,
} from "./actionTypes"

const initialState = {
  response: "",
  loading: false,
  error: "",
}

const GraphModal = (state = initialState, action) => {
  switch (action.type) {
    case GRAPH_MODAL_REQUEST:
      state = {
        ...state,
        response: "",
        loading: true,
        error: "",
      }
      break
    case GRAPH_MODAL_REQUEST_SUCCESS:
      state = {
        ...state,
        loading: false,
        response: action.payload.data
      }
      break
    case GRAPH_MODAL_REQUEST_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default GraphModal
